module.exports = {
    landing: {
        warranty: '24 Months Warranty'
    }
}